import './App.css';
import Weather from './weather';

function App() {
  return (
    <div className="App">
      <Weather/>
    </div>
  );
}

export default App;
